import React, {
  useRef,
} from 'react';
import {
  notEmptyString,
} from '@populateui/utils';
import ToolTip from 'core/components/Tooltip';
import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';
import {
  PCCCcmCallDTO,
} from 'dtos';
import {
  formatDuration,
} from 'pages/Dashboard/pages/Dashboard/CcmMonthly/helper';
import {
  formatDateTime,
} from 'utils/date';

type TextCellProps = {
  value?: string | null;
};

function TextCell({ value }: TextCellProps) {
  return (
    <span className="text-xs font-medium leading-4 text-gray-700">
      {notEmptyString(value) ? value : DEFAULT_EMPTY_VALUE}
    </span>
  );
}

function SummaryCell({ value }: TextCellProps) {
  const summaryRef = useRef<HTMLElement>(null);
  const displayValue = notEmptyString(value) ? value : DEFAULT_EMPTY_VALUE;

  const tooltipContent = notEmptyString(value) ? (
    <div className="flex flex-col gap-2 p-1 w-[600px]">
      <div className="text-sm font-semibold">Summary</div>
      <span className="text-xs font-medium leading-4 text-gray-700">
        {value}
      </span>
    </div>
  ) : DEFAULT_EMPTY_VALUE;

  return (
    <ToolTip
      title={tooltipContent}
      auto
      classes={{ tooltip: 'w-[400px] whitespace-pre-wrap break-words' }}
      ref={summaryRef}
      placement='left'
    >
      <span
        className="line-clamp-3 text-xs font-medium leading-4 text-gray-700"
        ref={summaryRef}
      >
        {displayValue}
      </span>
    </ToolTip>
  );
}

const columns: ColumnDef<PCCCcmCallDTO>[] = [{
  id: 'calledOn',
  accessorKey: 'calledOn',
  header: 'Called At',
  size: 140,
  cell: ({ row: { original } }) => (
    <TextCell
      value={notEmptyString(original.calledOn)
        ? formatDateTime(original.calledOn ?? '')
        : null}
    />
  ),
}, {
  id: 'durationSeconds',
  accessorKey: 'durationSeconds',
  header: 'Duration',
  size: 100,
  cell: ({ row: { original } }) => (
    <TextCell value={formatDuration(original.durationSeconds)} />
  ),
}, {
  id: 'callSummary',
  accessorKey: 'callSummary',
  header: 'Summary',
  minSize: 200,
  meta: { autoSized: true },
  cell: ({ row: { original } }) => (
    <SummaryCell value={original.callSummary} />
  ),
}];

export default columns;
